// Die Reiter der Detailseite und welche davon Wizard-Formulare sind.

import type { Run, Tenant, Checks } from "../../api/types";

export const TABS: ReadonlyArray<readonly [string, string]> = [
  ["", "Übersicht"],
  ["license", "Lizenz"],
  ["auth", "Anmeldung"],
  ["endpoints", "Endpoints"],
  ["models", "Modelle"],
  ["integrations", "Integrationen & Skills"],
  ["templates", "Vorlagen"],
  ["costs", "Kosten"],
  ["users", "Benutzer"],
  ["audit", "Audit-Log"],
  ["ops", "Betrieb"],
];

/** Reiter → Wizard-Schritt. „customer" hat keinen Reiter, nur „Bearbeiten" in der Übersicht. */
export const FORM_TABS: Readonly<Record<string, 1 | 2 | 3 | 4 | 5>> = { customer: 1, license: 2, auth: 3, endpoints: 4, integrations: 5 };

/** Schritt → Reiter (für die Links „Unvollständige Einstellungen"). */
export const TAB_OF_STEP: Readonly<Record<number, string>> = Object.fromEntries(Object.entries(FORM_TABS).map(([tab, n]) => [n, tab]));

/** Wie ein Reiter einen Lauf anstößt: Karte zeigen, optional hinscrollen, optional eigenes Ende. */
export interface RunStart {
  scroll?: boolean;
  onFinished?: (run: Run) => void;
}

export interface TabProps {
  tenant: Tenant;
  checks: Checks;
  onRunStarted: (run: Run, how?: RunStart) => void;
}
